import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
export type PatientCurrentVisitFragment = { readonly __typename?: 'Visit', readonly _id: string, readonly expiryStrategy?: Types.VisitExpiryStrategy | null, readonly admissionEvent?: { readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly type?: Types.VisitCareEventAction | null } | null, readonly insuranceList?: ReadonlyArray<{ readonly __typename?: 'InsuranceListItem', readonly isValidForVisit?: boolean | null, readonly visitInsuranceDetails?: unknown | null, readonly insurance: { readonly __typename?: 'VisitInsurance', readonly insuranceProvider?: { readonly __typename?: 'InsuranceProvider', readonly name?: string | null, readonly insuranceType?: string | null, readonly visitValidation?: { readonly __typename?: 'InsuranceVisitValidation', readonly expiryStrategy: Types.VisitExpiryStrategy } | null } | null } } | null> | null };

export const PatientCurrentVisitFragmentDoc = gql`
    fragment PatientCurrentVisit on Visit {
  _id
  expiryStrategy
  admissionEvent {
    _id
    type
  }
  insuranceList {
    insurance {
      insuranceProvider {
        name
        insuranceType
        visitValidation {
          expiryStrategy
        }
      }
    }
    isValidForVisit
    visitInsuranceDetails
  }
}
    `;